import Konva from 'konva'
import { Node, NodeConfig } from 'konva/lib/Node'

const GUIDELINE_OFFSET = 5

export function getLineGuideStops(stage: Konva.Stage, skipShape: Konva.Node) {
    const vertical: number[] = [0, stage.width() / 2, stage.width()]
    const horizontal: number[] = [0, stage.height() / 2, stage.height()]

    stage.find((node: Node<NodeConfig>) => {
        // ✅ skip transformer, guides, and the dragged node itself
        if (node === skipShape) return false
        if (node.hasName('guid-line')) return false
        if (node.getClassName() === 'Transformer') return false

        // ✅ only real drawable shapes & groups
        return node.getParent()?.getClassName() === 'Layer'
    }).forEach((guideItem) => {
        const box = guideItem.getClientRect({ skipTransform: false })

        vertical.push(
            box.x,
            box.x + box.width,
            box.x + box.width / 2
        )

        horizontal.push(
            box.y,
            box.y + box.height,
            box.y + box.height / 2
        )
    })

    return { vertical, horizontal }
}

export function getObjectSnappingEdges(node: Konva.Node) {
    const box = node.getClientRect({ skipTransform: false })
    const absPos = node.absolutePosition()

    return {
        vertical: [
            { guide: Math.round(box.x), offset: Math.round(absPos.x - box.x), snap: 'start' },
            { guide: Math.round(box.x + box.width / 2), offset: Math.round(absPos.x - box.x - box.width / 2), snap: 'center' },
            { guide: Math.round(box.x + box.width), offset: Math.round(absPos.x - box.x - box.width), snap: 'end' },
        ],
        horizontal: [
            { guide: Math.round(box.y), offset: Math.round(absPos.y - box.y), snap: 'start' },
            { guide: Math.round(box.y + box.height / 2), offset: Math.round(absPos.y - box.y - box.height / 2), snap: 'center' },
            { guide: Math.round(box.y + box.height), offset: Math.round(absPos.y - box.y - box.height), snap: 'end' },
        ],
    }
}

export function getGuides(lineGuideStops: any, itemBounds: any) {
    const resultV: any[] = []
    const resultH: any[] = []

    lineGuideStops.vertical.forEach((lineGuide: number) => {
        itemBounds.vertical.forEach((itemBound: any) => {
            const diff = Math.abs(lineGuide - itemBound.guide)
            if (diff < 5) {
                resultV.push({ ...itemBound, lineGuide, diff })
            }
        })
    })

    lineGuideStops.horizontal.forEach((lineGuide: number) => {
        itemBounds.horizontal.forEach((itemBound: any) => {
            const diff = Math.abs(lineGuide - itemBound.guide)
            if (diff < 5) {
                resultH.push({ ...itemBound, lineGuide, diff })
            }
        })
    })

    const guides: any[] = []

    const minV = resultV.sort((a, b) => a.diff - b.diff)[0]
    const minH = resultH.sort((a, b) => a.diff - b.diff)[0]

    if (minV) guides.push({ ...minV, orientation: 'V' })
    if (minH) guides.push({ ...minH, orientation: 'H' })

    return guides
}


export function drawGuides(layer: Konva.Layer, guides: any[]) {
    guides.forEach((lg) => {
        const line =
            lg.orientation === 'H'
                ? new Konva.Line({
                    points: [-6000, 0, 6000, 0],
                    stroke: '#3B82F6',
                    strokeWidth: 1,
                    dash: [4, 6],
                    name: 'guid-line',
                })
                : new Konva.Line({
                    points: [0, -6000, 0, 6000],
                    stroke: '#3B82F6',
                    strokeWidth: 1,
                    dash: [4, 6],
                    name: 'guid-line',
                })

        layer.add(line)

        line.absolutePosition(
            lg.orientation === 'H'
                ? { x: 0, y: lg.lineGuide }
                : { x: lg.lineGuide, y: 0 }
        )
    })
}
